const BGN_PER_EUR = 1.95583;

export const formatOrderDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  return new Intl.DateTimeFormat('bg-BG', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Sofia'
  }).format(date);
};

export const formatOrderMoney = (value, currency = 'BGN') => {
  if (value === null || value === undefined || value === '') return '—';
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';

  const amountInEur = String(currency).toUpperCase() === 'EUR' ? amount : amount / BGN_PER_EUR;
  return `${amountInEur.toFixed(2)} €`;
};

export const getOrderNumber = (order) => order?.uuidOrder || String(order?.id || '—');

export const getCustomerName = (order) =>
  [order?.firstName, order?.surname].filter(Boolean).join(' ').trim() || '—';

export const formatPaymentType = (value) => {
  const paymentType = String(value || '').trim();

  return /^Плащане\s+при\s+доставка(?=\s|\.|\(|$)/iu.test(paymentType)
    ? 'Плащане при доставка'
    : paymentType;
};

export const getAddressLines = (order) => {
  return [
    order?.streetAddress,
    order?.city && `град ${order.city}`,
    order?.county && `област ${order.county}`,
    order?.country
  ].filter(Boolean);
};
